import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Mercaderia } from 'src/app/model/index.model';
import { WorkshoppingService } from 'src/app/service/index.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-item-view',
  templateUrl: './item-view.component.html',
  styleUrls: ['./item-view.component.scss'],
  providers: [WorkshoppingService]
})
export class ItemViewComponent implements OnInit {
  @Input() product: Mercaderia;
  activeImage: string;
  quantity = 1;
  @Input() cotizacion: any;
  @Input() rol: number = 1

  url: string = environment.configUrl;
  conf: any

  constructor(
    private http: HttpClient,
    private wsdl: WorkshoppingService,
    public activeModal: NgbActiveModal) {

  }

  ngOnInit(): void {
    this.wsdl.registrarCliente();
    this.wsdl.cargarCarrito();
    this.http.get(this.url).subscribe(res => {
      this.conf = res;
    });

  }

  setActiveImage(img: string): void {
    this.activeImage = img;
  }

  increaseQty(): void {
    this.quantity++;
  }

  decreaseQty(): void {
    if (this.quantity > 1) this.quantity--;
  }

  addToCart(): void {

    this.activeModal.close(this.quantity)
  }

  get descripcionConSaltos(): string {
    if (!this.product?.descripcion) return '';
    return this.product.descripcion.replace(/\n/g, '<br>');
  }
}
